import { Box } from '@mui/material'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { getBranchList, getOwnParentCompany, updateAlertError, updateModal } from '../../../../store/common/common_action'
import {
  getDispatchReportInputFilters,
  getDispatchReportDetailsFilter,
  getCargoSettingFilterData,
} from '../../../../store/reports/reports_action'
import { nameAll, reportOptionsDetailedViewDispatchFilter, reportTypeDispatchFilter } from '../../../common/constants'
import { reportViewDispatchFilter, reportOptionsSummaryViewDispatchFilter } from '../../../common/constants'
import Datepicker from '../../../common/datePicker'
import DropDownOA from '../../../common/dropDownOA'
import { divideInNIntegers } from '../../../../components/common/mathHelper'
import {
  appendToUrl,
  extractAndFilter,
  focusElemnt,
  isEmpty,
  navigation3,
  removeDuplicatesFromArray,
  removeDuplicatesFromArray1,
  addMisssingValue
} from '../../../common/helper'
import { modeAllPayments, paymentModesWithAll } from '../../../common/paymentsMode'
import { Item } from '../../../common/snippets'
import { SplitButton } from '../../../common/SplitButton'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { RefreshSvg } from '../../../common/svg/refresh'
import { ReportHeading } from '../common/ReportHeading'
import * as lb from '../reportLables'
import * as urls from '../oldReportsUrls'
import { urls as urls2 } from '../../../../components/common/constants'
import { GetRequest } from '../../../../components/common/api'
import DispatchReportTable from './DispatchTable'
import {
  GroupDataVWC,
  GroupDataVWCSecond,
  groupDataByVehicleAndPayment,
} from '../common/reportUtils'
import {
  calculateTotals,
  coloumnDispatchDetails11,
  coloumnDispatchDetails12,
  coloumnDispatchDetails1WithFormatLR,
  coloumnDispatchDetails2,
  prepareVehicleWiseData,
  showOnlyToPayCol,
  showOnlyToPayColTwo,
  showOnlyToPayColWithFormat,
  showOnlyToPayColWithFormatTwo,
  vehicleAndTripWiseDispatchCols,
  withPaymentTypeCol,
  withPaymentTypeColWithFormat,
  withVehicleANdChartCol,
  withVehicleANdChartColTwo,
  withStaDispatchColumns,
} from '../common/reportConstants'
import {
  buildDispatchCriteriaHeaders,
  buildDispatchCriteriaData,
  buildSection5MainHeader,
  buildSection6MainHeader,
  getWithOtherChargesSummaryMainHeader,
  getOtherChargesMainHeader,
  getVehicleWiseDispatchSummaryMainHeader,
  transformHamaliAndCartage,
  transformBranchSummary,
  transformWithOtherCharges,
  transformVehicleWiseDispatch,
  transformOtherCharges,
  openReportInNewTab,
  transformChallanWiseDispatch,
  buildChallanWiseDispatchMainHeader,
  buildDetailedVWCMainHeader,
  transformPaymentTypeGroup,
  buildPaymentTypeGroupMainHeader,
  buildVehicleWiseDispatchDetailedMainHeader,
  transformVehicleWiseSummaryDetailed,
  transformVehicleWiseDispatchDetailed,
  buildShowOnlyToPaySummaryHeader,
  buildShowOnlyToPayMainHeader,
  transformShowOnlyToPay,
  buildStatuswiseSummaryMainHeader,
  transformStatuswiseSummary,
  buildBranchwiseSummaryCityMainHeader,
  transformBranchwiseSummaryCity,
  transformTripCitywiseDispatch
} from './DispatchReportUtils'
import { updateAlert, updateLoader } from '../../../../store/common/common_action'
import { useDispatch } from 'react-redux'
import { DEMO_COMPANY, DEUBEY_JS, DUBEY_TRAVEL, JAI_MAA_BHADRA_KAALI, JAIN_COMPANY_ID, JAIN_NEW, NEELKANTH_TRAVELS, RAJESH_TRANSPORT, SHRI_BABU } from '../../../../helper/companyIdhardcode'
import { ChildCompanyListData, fetchChildCompanyListData } from '../../../common/jotaiState/reportStateAtom'
import { useAtom } from 'jotai'

const DispatchReportNew = (props) => {
  const {
    data,
    getDispatchReportDetailsFilter,
    updateAlertError,
    getCargoSettingFilterData,
    updateAlert,
  } = props
  const { common, reports } = data
  const dispatch = useDispatch()
  const { loginData, showModal, modalType, roleRights, companySettings } = common
  const { intCompanyID, intUserID } = loginData
  const {
    dispatchDetailsData,
    cargoSettingFilterData,
  } = reports

  const allownFormatLR = companySettings?.[0]?.UseFormattedLRinReports
  const loginCountryId = companySettings[0]?.DefaultCurrencyID
  const DispatchReportPortrait = companySettings?.[0]?.DispatchReportPortrait || 0
  const UseToPayAsCOD = companySettings[0]?.UseToPayAsCOD

  const [selCompany, setSelCompany] = useState(false)
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [selFromBranch, setSelFromBranch] = useState('')
  const [selDestCity, setSelDestCity] = useState(nameAll)
  const [selBranch, setSelBranch] = useState(nameAll)
  const [selVehicle, setSelVehicle] = useState(nameAll)
  const [selPaymentTpe, setSelPaymentType] = useState(modeAllPayments)
  const [reportType, setReportType] = useState(reportTypeDispatchFilter[0])
  const [showSummaryReport, setShowSummaryReport] = useState(reportViewDispatchFilter[1])
  const [detailedFilter, setDetailedFilter] = useState()
  const [showReport, setShowReport] = useState(false)
  const [reportOptionsData, setReportOptionsData] = useState(reportOptionsSummaryViewDispatchFilter)
  const [manageColumn, setManageColumn] = useState([])
  const [disableBtn, setDisableBtn] = useState(false)
  const [disableExcel, setDisableExcel] = useState(false)
  const [vehicleData, setVehicleData] = useState([])
  const [, fetchChildCompanyList] = useAtom(fetchChildCompanyListData)
  const [ChildCompanyList] = useAtom(ChildCompanyListData)
  const { AllowGroupofCompanies = 0 } = roleRights?.Table1?.[0] || {}

  useEffect(() => {
    if (AllowGroupofCompanies === 1) {
      const defaultCompany =
        ChildCompanyList.find((v) => v.CompanyID === loginData.intCompanyID) ||
        ChildCompanyList[0];
      setSelCompany(defaultCompany);
    } else {
      setSelCompany({
        CompanyID: loginData.intCompanyID,
        CompanyName: loginData.strCompanyName
      });
    }
  }, [ChildCompanyList, AllowGroupofCompanies]);
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const body = {
        intCompanyID: intCompanyID,
        UserID: intUserID
      }
      fetchChildCompanyList(body)
    }
  }, [loginData])
  useEffect(() => {
    if (dispatchDetailsData && dispatchDetailsData.length > 0) {
      setVehicleData(
        removeDuplicatesFromArray1(
          extractAndFilter(dispatchDetailsData, 'VehicleNoForFilter', 'VehicleIDForFilter', true, 'DispatchedToCityIDFilter'),
          'id',
          'name'
        )
      )
    }
  }, [dispatchDetailsData])

  useEffect(() => {
    if (!isEmpty(roleRights) && !isEmpty(loginData)) {
      setDisableBtn(
        !(
          roleRights?.Table1?.[0]?.AllowViewAllBranchReport ||
          roleRights?.Table1?.[0]?.AllowBranchInchargeRights ||
          loginData?.IsBranchAdmin ||
          loginData?.IsMTPLAdmin ||
          loginData?.IsAdmin
        )
      )
      setDisableExcel(!roleRights?.Table1?.[0]?.AllowExportExcel)
    }
  }, [roleRights, loginData])

  useEffect(() => {
    if (!localStorage.getItem('isUpdated')) {
      localStorage.removeItem('coloumnDispatchDetails1')
      localStorage.removeItem('coloumnDispatchDetails2')
      localStorage.removeItem('KeyVehicleAndChartCol2_0708')

      localStorage.setItem('isUpdated', 'true')
    }
  }, [])

  useEffect(() => {
    if (!isEmpty(loginData)) {
      const obj = {
        intCompanyID: loginData?.intCompanyID,
        intBranchID: loginData?.intBranchID,
        intUserID: loginData?.intUserID,
      }
      getCargoSettingFilterData(obj)
    }
  }, [loginData])
  //  const DispatchReportPortrait = 1
  const makeColumnsMandatory = (columns, fields = []) => {
    return columns.map(col =>
      fields.includes(col.field)
        ? { ...col, isMandatory: true, isDefault: true }
        : col
    )
  }
  useEffect(() => {
    const getLocalData = (key) => {
      return new Promise((resolve) => {
        const localData = localStorage.getItem(key)
        resolve(localData ? JSON.parse(localData) : null)
      })
    }
    const updateColumnDetails = async () => {
      try {
        const localColoumnDispatchDetails1 = await getLocalData('keyVehicleWiseDisptchCol1_1011')
        const localcolDispatchDetails1WithFormatLR = await getLocalData('keyDispatchDetailsFormatLR1_1211')
        const localColoumnDispatchDetails2 = await getLocalData('KeyVehicleWiseDisptchCol2_0708')
        const localWithVehicleANdChartCol =
          loginCountryId !== 2 ? await getLocalData('KeyVehicleAndChartCol_0708') : await getLocalData('KeyVehicleAndChartCol2_0708')
        const localWithPaymentTypeCol = await getLocalData('KeyPaymentTypeCol_0708')
        const localWithPaymentTypeColWithFormat = await getLocalData('KeyPaymentTypeColWithFormat_0708')
        const LoaclShowOnlyToPayCol =
          loginCountryId !== 2 ? await getLocalData('KeyOnlyToPayCol_0708') : await getLocalData('KeyOnlyToPayCol2_0708')
        const LoaclShowOnlyToPayColWithFormat =
          loginCountryId !== 2 ? await getLocalData('KeyOnlyToPayColWithFormat_0708') : await getLocalData('KeyOnlyToPayColWithFormat2_0708')
        let data = []
        const dispatchCompanyId = selCompany?.CompanyID ?? loginData?.intCompanyID
        const coloumnDispatchDetails1 =
          loginCountryId === 2
            ? coloumnDispatchDetails12(dispatchCompanyId)
            : coloumnDispatchDetails11(dispatchCompanyId)
        if (detailedFilter?.id === 0 || detailedFilter?.Name === 'Crossing Dispatch') {
          if (reportType?.id === 0) {
            if (allownFormatLR === 3) {
              data = withStaDispatchColumns(
                localcolDispatchDetails1WithFormatLR || coloumnDispatchDetails1WithFormatLR(dispatchCompanyId),
                dispatchCompanyId
              )
            } else {
              data = withStaDispatchColumns(localColoumnDispatchDetails1 || coloumnDispatchDetails1, dispatchCompanyId)
            }
          } else {
            data = withStaDispatchColumns(
              localColoumnDispatchDetails2 || coloumnDispatchDetails2(dispatchCompanyId),
              dispatchCompanyId
            )
          }
        } else if (detailedFilter?.id === 1) {
          if (loginCountryId !== 2) {
            data = localWithVehicleANdChartCol || withVehicleANdChartCol
          } else {
            data = localWithVehicleANdChartCol || withVehicleANdChartColTwo
          }
          if (UseToPayAsCOD === 1) {
            data = data.map((col) => {
              if (col.field === "topayCount") {
                return { ...col, header: "COD\nLRs", pdfHead: "COD\nLRs" };
              } else if (col.field === "totalToPayCodFreight") {
                return { ...col, header: "COD\nFreight", pdfHead: "COD\nFreight" };
              } else if (col.field === "totalToPayCodGstOther") {
                return { ...col, header: "COD\nGST+Oth", pdfHead: "COD\nGST+Oth" };
              }
              return col;
            });
          }
        } else if (detailedFilter?.id === 2) {
          if (allownFormatLR === 3) {
            data = localWithPaymentTypeColWithFormat || withPaymentTypeColWithFormat
          } else {
            data = localWithPaymentTypeCol || withPaymentTypeCol
          }
        } else if (detailedFilter?.id === 3) {
          if (allownFormatLR === 3) {
            if (loginCountryId !== 2) {
              data = LoaclShowOnlyToPayColWithFormat || showOnlyToPayColWithFormat
            } else {
              data = LoaclShowOnlyToPayColWithFormat || showOnlyToPayColWithFormatTwo
            }
          } else {
            if (loginCountryId !== 2) {
              data = LoaclShowOnlyToPayCol || showOnlyToPayCol
            } else {
              data = LoaclShowOnlyToPayCol || showOnlyToPayColTwo
            }
          }
          if (UseToPayAsCOD === 1) {
            data = data.map((col) => {
              if (col.field === "2") return { ...col, header: "COD" };
              if (col.field === "7") return { ...col, header: "COD (Manual)" };
              if (col.field === "9") return { ...col, header: "COD (DDDV)" };
              return col;
            }).filter((col) => col.field !== "4");
          }
        }
        if (DispatchReportPortrait === 1) {
          if (loginData?.intCompanyID === SHRI_BABU) {
            const removeFields = ['BookingDateTime', 'ItemDetails']
            data = data.filter(col => !removeFields.includes(col.field))
            data = makeColumnsMandatory(data, ['SenderName', 'RecName'])
          }
          data = data.filter((item) => item.isMandatory === true)
        }
        if ([DUBEY_TRAVEL, DEUBEY_JS].includes(intCompanyID)) {
          const idx = data.findIndex(item => item.header === 'Total');
          if (idx !== -1) {
            data[idx] = { ...data[idx], isMandatory: false };
          }
        }
        if (loginCountryId === 2) {
          data = data.map((col) => {
            if (col.field === "Insurance") {
              return {
                ...col,
                header: "Insurance\nCharge",
                pdfHead: "Insurance\nCharge",
              };
            }
            return col;
          });
        }
        if (RAJESH_TRANSPORT === loginData?.intCompanyID) {
          const hasRestrictedFields = data.some(col =>
            ["SenderName", "RecName"].includes(col.field)
          );

          if (hasRestrictedFields) {
            data = data.filter(
              col => !["SenderName", "RecName"].includes(col.field)
            );
          }
        }
        setManageColumn(data)
      } catch (error) {
        console.error(error)
      }
    }
    updateColumnDetails()
  }, [reportType?.id, detailedFilter?.id, detailedFilter?.Name, allownFormatLR, DispatchReportPortrait])

  useEffect(() => {
    if (showSummaryReport?.id === 0) {
      setReportOptionsData(reportOptionsSummaryViewDispatchFilter)
      setDetailedFilter(reportOptionsSummaryViewDispatchFilter[0])
    } else {
      setReportOptionsData(reportOptionsDetailedViewDispatchFilter)
      setDetailedFilter(reportOptionsDetailedViewDispatchFilter[0])
    }
  }, [showSummaryReport])

  useEffect(() => {
    focusElemnt('fromDate')
  }, [])
  useEffect(() => {
    if (dispatchDetailsData?.length > 0) {
      let BranchOption = [
        ...extractAndFilter(dispatchDetailsData, 'DispatchFromBranchFilter', 'DispatchFromBranchIDFilter', false, 'FromCityID'),
      ]
      const selectedBranch = BranchOption?.filter((val) => val.id === loginData?.intBranchID)
      if (disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0) {
        setSelFromBranch({ cityId: loginData?.intBranchCityID, id: loginData?.intBranchID, name: loginData?.strBranchName })
      } else {
        if (selectedBranch?.length > 0) {
          setSelFromBranch(selectedBranch?.[0])
        } else {
          setSelFromBranch({ name: 'All', id: 0 })
        }
      }
    } else {
      setSelFromBranch('')
    }
  }, [dispatchDetailsData])


  const handleClick1 = async () => {
    const diffDays = Math.abs(toDate.diff(fromDate, 'days'))
    const isAllSelected = selFromBranch?.id === 0 || selFromBranch?.name === 'All' || selDestCity?.id === 0 || selDestCity?.name === 'All' || selBranch?.id === 0 || selBranch?.name === 'All'

    if (selFromBranch === '' || selFromBranch === ' ') {
      updateAlertError({ show: true, msg: 'Select Dispatch Branch', nextId: '' })
      return
    }
    if (isAllSelected && diffDays > 15) {
      updateAlertError({ show: true, msg: 'For All selection, date range cannot exceed 15 days', nextId: '' })
      return
    }
    if (!isAllSelected && diffDays > 31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
      return
    }

    // params used by multiple API calls
    const commonParams = {
      intFromCityID: 0,
      intFromBranchID: selFromBranch === 0 ? 0 : selFromBranch?.id,
      intToCityID: selDestCity?.DestinationCity === 'All' ? 0 : selDestCity?.id,
      intToBranchID: selBranch?.DestinationBranch === 'All' ? 0 : selBranch.id,
      intCompanyID: selCompany?.CompanyID,
      dtFrom: fromDate.format('YYYY-MM-DD'),
      dtTo: toDate.format('YYYY-MM-DD'),
      intUserID: loginData?.intUserID,
      strVehicleNo: selVehicle?.name === 'All' ? '--All--' : selVehicle?.name,
      intPaymentType: selPaymentTpe === 0 ? 0 : selPaymentTpe?.typeId,
      LoginUserID: intUserID,
      IsOnlyCancelledDispatch: reportType?.Name === 'Dispatch' ? 0 : 1,
    }

    // helper to build the subheader row (used in every report)
    const buildSubHeaderRow = (mainHeader) => {
      const lengths = divideInNIntegers(mainHeader.length, 3)
      let index = 0
      const pickedHeaders = []
      lengths.forEach((span) => { pickedHeaders.push(mainHeader[index]?.field); index += span })
      return {
        dataType: 'subHeader',
        totalSubKey: 3,
        colSpan: Object.fromEntries(pickedHeaders.map((key, i) => [key, lengths[i]])),
        align: { [pickedHeaders[0]]: 'left', [pickedHeaders[1]]: 'center', [pickedHeaders[2]]: 'right' },
        [pickedHeaders[0]]: `Dispatch By Branch: ${selFromBranch?.name || loginData?.strBranchName}`,
        [pickedHeaders[1]]: `Destination City: ${selDestCity?.name || 'All'}`,
        [pickedHeaders[2]]: `Destination Branch: ${selBranch?.name || 'All'}`,
      }
    }

    const criteriaHeaders = buildDispatchCriteriaHeaders()
    const criteriaData = [buildDispatchCriteriaData({ fromDate, toDate, selFromBranch, selDestCity, selBranch, selVehicle, selPaymentTpe, reportType, showSummaryReport, detailedFilter, loginData })]

    try {
      dispatch(updateLoader(true))

      //Challan Wise Dispatch (Summary)
      if (showSummaryReport?.id === 0 && detailedFilter?.Name === 'Challan Wise Dispatch') {
        const res = await GetRequest(urls2.getChallanWiseDispatchData, {
          intBranchID: selFromBranch === 0 ? 0 : selFromBranch?.id,
          intCompanyID: selCompany?.CompanyID,
          dispatchdate: fromDate.format('YYYY-MM-DD'),
          dispatchTodate: toDate.format('YYYY-MM-DD'),
          VehicleNo: selVehicle?.name === 'All' ? '--All--' : selVehicle?.name,
          intUserID,
          intConsignmentType: 0,
          AllowViewAllReport: 1,
        })

        if (!res?.Data?.Table?.length) {
          updateAlertError({ show: true, msg: 'No records found', nextId: '' })
          return
        }

        const mainHeader = buildChallanWiseDispatchMainHeader()
        const tableData = transformChallanWiseDispatch(res.Data.Table)
        openReportInNewTab({
          reportName: 'Dispatch Report - Challan Wise Dispatch (Summary123)',
          criteriaHeaders,
          criteriaData,
          mainHeader,
          tableData,
          serialNokey: 'SN',
          showColumnBorders: true,
          isWrapEntryText: true,
          isClampHeaderToTwoLines: true,
        })
        return
      }

      //Summary variants (Hamali / OtherCharges / Branch / VehicleWise)
      if (
        detailedFilter?.Name === 'With Hamali and Cartage' ||
        detailedFilter?.Name === 'With Other Charges' ||
        detailedFilter?.Name === 'Other Charges' ||
        detailedFilter?.Name === 'Branch Summary' ||
        detailedFilter?.Name === 'Vehicle Wise Dispatch'
      ) {
        const res = await GetRequest(urls2.getDispatchReportSummaryFilter, {
          ...commonParams,
          strVehicleNo: selVehicle?.name === 'All' ? '--All--' : selVehicle?.id,
          VehicleID: selVehicle?.name === 'All' ? 0 : selVehicle?.id,
        })

        const table1 = res?.Data?.Table
        const table1Alt = res?.Data?.Table1
        const table2 = res?.Data?.Table2
        const filterName = detailedFilter?.Name

        let tableData = [], mainHeader = [], reportLabel = ''

        if (filterName === 'With Hamali and Cartage' && table1?.length) {
          tableData = transformHamaliAndCartage(table1)
          mainHeader = buildSection6MainHeader(loginCountryId, UseToPayAsCOD)
          reportLabel = 'With Hamali and Cartage (Summary)'
        } else if (filterName === 'Branch Summary' && table1Alt?.length) {
          tableData = transformBranchSummary(table1Alt)
          mainHeader = buildSection6MainHeader(loginCountryId, UseToPayAsCOD)
          reportLabel = 'Branch Summary'
        } else if (filterName === 'With Other Charges' && table1Alt?.length) {
          tableData = transformWithOtherCharges(table1Alt)
          mainHeader = getWithOtherChargesSummaryMainHeader(loginCountryId, UseToPayAsCOD)
          reportLabel = 'With Other Charges (Summary)'
        } else if (filterName === 'Other Charges' && table1Alt?.length) {
          tableData = transformOtherCharges(table1Alt)
          mainHeader = getOtherChargesMainHeader(UseToPayAsCOD)
          reportLabel = 'Other Charges (Summary)'
        } else if (filterName === 'Vehicle Wise Dispatch' && table2?.length) {
          tableData = transformVehicleWiseDispatch(table2)
          mainHeader = getVehicleWiseDispatchSummaryMainHeader(UseToPayAsCOD)
          reportLabel = 'Vehicle Wise Dispatch (Summary)'
        } else {
          updateAlertError({ show: true, msg: 'No Dispatch In Selected Date', nextId: '' })
          return
        }
        let subHeaderRow = []
        if (filterName === 'With Other Charges' && table1Alt?.length) {
          subHeaderRow = {
            dataType: 'subHeader',
            totalSubKey: 3,
            colSpan: { 'BusNumber^^SealNo': 8, 'TopayFreight': 5, 'TopayCodGstOth': 5, Insurance: 4 },
            align: { 'BusNumber^^SealNo': 'left', 'TopayFreight': 'center', 'Insurance': 'right' },
            'BusNumber^^SealNo': `Dispatch By Branch: ${selFromBranch?.name || loginData?.strBranchName}`,
            'TopayFreight': `Destination City: ${selDestCity?.name || 'All'}`,
            'Insurance': `Destination Branch: ${selBranch?.name || 'All'}`,
            'TotalUnits': '',
            'TotalFreight': '',
            'NetOther': '',
            'TopayCodGstOth': "",
          }
        }else if(filterName === 'Other Charges' && table1Alt?.length){
          subHeaderRow = {
            dataType: 'subHeader',
            totalSubKey: 3,
            colSpan: { 'srNo': 6, 'PaidFreight': 3, 'PaidOther': 3, 'PaidGST': 3, 'TotalPaid': 5 },
            align: { 'srNo': 'left', 'PaidOther': 'left', 'TotalPaid': 'right' },
            'srNo': `Dispatch By Branch: ${selFromBranch?.name || loginData?.strBranchName}`,
            'PaidOther': `Destination City: ${selDestCity?.name || 'All'}`,
            'TotalPaid': `Destination Branch: ${selBranch?.name || 'All'}`,
            'Station': '',
            'DDDVFreight': '',
            'PaidFreight': '',
            'DDDVOther': '',
            'PaidGST': '',
            'DDDVGST': '',
          }
        }else{
          subHeaderRow = buildSubHeaderRow(mainHeader)
        }
        openReportInNewTab({
          reportName: `Dispatch Report - ${reportLabel}`,
          criteriaHeaders,
          criteriaData,
          mainHeader,
          tableData: [subHeaderRow, ...tableData],
          serialNokey: filterName === 'Other Charges' ? 'srNo' : 'SN',
          showColumnBorders: true,
        })
        return
      }

      //With Vehicle and Chart Date (Summary)
      if (showSummaryReport?.id === 0 && detailedFilter?.Name === 'With Vehicle and Chart Date') {
        const res = await GetRequest(urls2.getDispatchMemoDetailFilter, commonParams)

        if (!res?.Data?.Table?.length) {
          updateAlertError({ show: true, msg: 'No Dispatch In Selected Date', nextId: '' })
          return
        }

        const updatedTable = addMisssingValue(res.Data.Table)
        const mainHeader = buildSection5MainHeader(loginCountryId, UseToPayAsCOD)

        const vehicleGroupData = GroupDataVWC(updatedTable)

        const subHeaderRow = buildSubHeaderRow(mainHeader)
        openReportInNewTab({
          reportName: 'Dispatch Report - With Vehicle & Chart Date (Summary)',
          criteriaHeaders,
          criteriaData,
          mainHeader,
          tableData: [subHeaderRow, ...vehicleGroupData],
          showColumnBorders: true,
        })
        return
      }

      //Statuswise Summary
      if (showSummaryReport?.id === 0 && detailedFilter?.Name === 'Statuswise Summary') {
        const res = await GetRequest(urls2.getDispatchReportSummaryFilter, {
          ...commonParams,
          strVehicleNo: selVehicle?.name === 'All' ? '--All--' : selVehicle?.id,
          VehicleID: selVehicle?.name === 'All' ? 0 : selVehicle?.id,
        })

        if (!res?.Data?.Table3?.length) {
          updateAlertError({ show: true, msg: 'No Dispatch In Selected Date', nextId: '' })
          return
        }

        const mainHeader = buildStatuswiseSummaryMainHeader().map((col, index) =>
          index === 0 ? { ...col, hideHeader: true } : col
        )
        const tableData = transformStatuswiseSummary(res.Data.Table3, selFromBranch?.name || loginData?.strBranchName)

        openReportInNewTab({
          reportName: 'Dispatch Report - Statuswise Summary',
          criteriaHeaders,
          criteriaData,
          mainHeader,
          tableData,
          hideHeader: true,
          serialNokey: 'SN',
          showColumnBorders: true,
          enableHorizontalScroll: true,
          minTableWidth: '1350px',
        })
        return
      }

      //City in Branchwise Summary
      if (showSummaryReport?.id === 0 && detailedFilter?.Name === 'City in Branchwise Summary') {
        const res = await GetRequest(urls2.getDispatchReportSummaryFilter, {
          ...commonParams,
          strVehicleNo: selVehicle?.name === 'All' ? '--All--' : selVehicle?.id,
          VehicleID: selVehicle?.name === 'All' ? 0 : selVehicle?.id,
        })

        if (!res?.Data?.Table4?.length) {
          updateAlertError({ show: true, msg: 'No Dispatch In Selected Date', nextId: '' })
          return
        }

        const mainHeader = buildBranchwiseSummaryCityMainHeader()
        const tableData = transformBranchwiseSummaryCity(res.Data.Table4)

        openReportInNewTab({
          reportName: 'Dispatch Report - City in Branchwise Summary',
          criteriaHeaders,
          criteriaData,
          mainHeader,
          tableData,
          serialNokey: 'SN',
          showColumnBorders: true,
        })
        return
      }

      //Trip in Citywise Dispatch
      if (showSummaryReport?.id === 0 && detailedFilter?.Name === 'Trip in Citywise Dispatch') {
        const res = await GetRequest(urls2.getDispatchReportSummaryFilter, {
          ...commonParams,
          strVehicleNo: selVehicle?.name === 'All' ? '--All--' : selVehicle?.id,
          VehicleID: selVehicle?.name === 'All' ? 0 : selVehicle?.id,
        })

        if (!res?.Data?.Table5?.length) {
          updateAlertError({ show: true, msg: 'No Dispatch In Selected Date', nextId: '' })
          return
        }

        const { mainHeader, tableData, tables } = transformTripCitywiseDispatch(res.Data.Table5)
        const updatedMainHeader = mainHeader.map((col, index) =>
          index === 0 ? { ...col, hideHeader: true } : col
        )
        const updatedTables = tables.map((table, tableIndex) => {
          const excelHeaderTitle = table.tableData?.[0]?.dataType === 'subHeader'
            ? table.tableData[0]?.DispatchFromCity
            : ''
          const shouldUseTripHeaderForExcel = excelHeaderTitle?.startsWith('Trip Name:')

          return {
            ...table,
            criteriaHeaders: tableIndex === 0 ? criteriaHeaders : undefined,
            criteriaData: tableIndex === 0 ? criteriaData : undefined,
            excelTableData: shouldUseTripHeaderForExcel ? table.tableData.slice(1) : table.tableData,
            mainHeader: table.mainHeader.map((col, index) => ({
              ...col,
              ...(index === 0 ? { hideHeader: true } : {}),
              ...(shouldUseTripHeaderForExcel ? { exportHead: index === 0 ? excelHeaderTitle : '' } : {}),
            })),
          }
        })
        openReportInNewTab({
          reportName: 'Dispatch Report - Trip in Citywise Dispatch',
          criteriaHeaders,
          criteriaData,
          mainHeader: updatedMainHeader,
          tableData,
          isMultiTable: true,
          tables: updatedTables,
          hideHeader: true,
          showColumnBorders: true,
          enableHorizontalScroll: true,
          minTableWidth: `${Math.max(1100, mainHeader.length * 90)}px`,
          isShowPdfPrint: false,
        })
        return
      }

      //With Vehicle and Chart Date (Detailed)
      if (showSummaryReport?.id === 1 && detailedFilter?.Name === 'With Vehicle and Chart Date') {
        const res = await GetRequest(urls2.getDispatchMemoDetailFilter, commonParams)

        if (!res?.Data?.Table?.length) {
          updateAlertError({ show: true, msg: 'No Dispatch In Selected Date', nextId: '' })
          return
        }

        const updatedTable = addMisssingValue(res.Data.Table)
        const mainHeader = buildDetailedVWCMainHeader(loginCountryId, UseToPayAsCOD, intCompanyID)

        const groupDataSecond = GroupDataVWCSecond(updatedTable)
        const subHeaderRow = buildSubHeaderRow(mainHeader)
        openReportInNewTab({
          reportName: 'Dispatch Report - With Vehicle & Chart Date (Detailed)',
          criteriaHeaders,
          criteriaData,
          mainHeader,
          tableData: [subHeaderRow, ...groupDataSecond],
          colSpanMarker: 'SummaryToCity',
          totalSubKey: 3,
          isShowManageColumn: true,
          manageColumnID: loginCountryId !== 2 ? 'KeyVehicleAndChartCol_0708' : 'KeyVehicleAndChartCol2_0708',
          showColumnBorders: true,
        })
        return
      }
      if (showSummaryReport?.id === 1 && detailedFilter?.id === 4) {
        const res = await GetRequest(urls2.getDispatchMemoDetailFilter, commonParams)
        if (!res?.Data?.Table?.length) {
          updateAlertError({ show: true, msg: 'No Dispatch In Selected Date', nextId: '' })
          return
        }
        const tableData = res?.Data?.Table?.map((item,index) => ({ ...item, SN: index + 1,dataType:'entry' })) || [];
        const updatedTable = prepareVehicleWiseData(tableData, vehicleAndTripWiseDispatchCols);
        openReportInNewTab({
          reportName: 'Dispatch Report -  Tripsheet wise Vehicle Dispatch',
          criteriaHeaders,
          criteriaData,
          mainHeader: vehicleAndTripWiseDispatchCols,
          tableData: updatedTable,
          isShowManageColumn: true,
          manageColumnID: '21e12d12e1',
          serialNokey:'SN',
          showColumnBorders: true,
        })
        return
      }

      //remaining Detailed views
      if (showSummaryReport?.id === 1) {
        if (!dispatchDetailsData.length) return

        const res = await GetRequest(urls2.getDispatchDetailsFilter, commonParams)

        if (!res?.Data?.Table?.length) {
          updateAlertError({ show: true, msg: 'No Dispatch In Selected Date', nextId: '' })
          return
        }

        const table = res?.Data?.Table?.map((item) => ({
          ...item,
          Remarks: item.DispatchRemark,
          PaymentType:
            loginCountryId === 2
              ? UseToPayAsCOD === 1 &&
                item.PaymentTypeInt === 2 &&
                item.PaymentType === 'TO PAY'
                ? 'COD'
                : item.PaymentTypeInt === 7
                  ? 'COD(MANUAL)'
                  : item.PaymentType
              : item.PaymentType,
        }));

        // With Payment Type Group(Detailed)
        if (detailedFilter?.Name === 'With Payment Type Group') {
          const mainHeader = buildPaymentTypeGroupMainHeader(allownFormatLR,intCompanyID)
          const tableData = transformPaymentTypeGroup(table, mainHeader, allownFormatLR)
          const subHeaderRow = buildSubHeaderRow(mainHeader)
          openReportInNewTab({
            reportName: 'Dispatch Report - With Payment Type Group (Detailed)',
            criteriaHeaders,
            criteriaData,
            mainHeader,
            tableData: [subHeaderRow, ...tableData],
            isShowManageColumn: true,
            isMultiSplit: true,
            manageColumnID: allownFormatLR === 3 ? 'KeyPaymentTypeColWithFormat_0708' : 'KeyPaymentTypeCol_0708',
            totalSubKey: 3,
            colSpanMarker: 'ItemDetails',
            serialNokey: 'SN',
            showColumnBorders: true,
          })
          return
        }

        // Vehicle Wise Dispatch(Detailed) and Crossing Dispatch(Detailed)
        const isCrossingDispatch = detailedFilter?.Name === 'Crossing Dispatch'
        if (detailedFilter?.Name === 'Vehicle wise Dispatch' || isCrossingDispatch) {
          const INCREASED_PDF_FONT_COMPANY_IDS = [JAI_MAA_BHADRA_KAALI, NEELKANTH_TRAVELS]
          const useIncreasedPdfFont = INCREASED_PDF_FONT_COMPANY_IDS.includes(intCompanyID)
          let mainHeader = buildVehicleWiseDispatchDetailedMainHeader(loginCountryId, allownFormatLR, reportType?.id,intCompanyID).filter(col => !col.isSummaryHeader)
          if (isCrossingDispatch) {
            mainHeader = mainHeader.map(col =>
              col.field === 'DispatchedToCityFilter'
                ? { ...col, header: 'Crossing City \nCrossing Br.', exportHead: 'Crossing City \nCrossing Br.' }
                : col
            )
          }

          const reportTable = isCrossingDispatch
            ? table.filter((item) => Number(item.IsCrossing) === 1)
            : table

          if (isCrossingDispatch && !reportTable.length) {
            updateAlertError({ show: true, msg: 'No Dispatch In Selected Date', nextId: '' })
            return
          }

          const tableData = transformVehicleWiseDispatchDetailed(reportTable, mainHeader)
          const summaryData = transformVehicleWiseSummaryDetailed(reportTable)
          const summaryHeader = manageColumn
            .filter(col => col?.isSelected && col.isSummaryHeader)
            .map(col => ({
              field: col.field,
              header: col.header,
              exportHead: col.pdfHead || col.header,
              align: 'right',
              xlCol: col.xlCol,
              weight: 40,
              isSortIcon: col.isSortIcon,
            }))

          const subHeaderRow = buildSubHeaderRow(mainHeader)
          openReportInNewTab({
            reportName: isCrossingDispatch
              ? 'Dispatch Report - Crossing Wise Dispatch (Detailed)'
              : 'Dispatch Report - Vehicle Wise Dispatch (Detailed)',
            mainHeader,
            isMultiTable: true,
            isClampHeaderToTwoLines: true,
            isWrapEntryText: true,
            minTableWidth: '100%',
            tables: [
              {
                criteriaHeaders,
                criteriaData,
                mainHeader,
                tableData: [subHeaderRow, ...tableData],
                totalSubKey: 3,
                colSpanMarker: 'VehicleNo',
                serialNokey: 'SN',
                isClampHeaderToTwoLines: true,
                isWrapEntryText: true,
                enableHorizontalScroll: true,
              },
              { mainHeader: summaryHeader, tableData: summaryData },
            ],
            isShowManageColumn: true,
            manageColumnID: 'KeyVehicleWiseDisptchCol2_070815',
            showColumnBorders: true,
            isIncreFontSize: useIncreasedPdfFont,
            pdfFontSize: useIncreasedPdfFont ? 1.214 : 1,
            //isMultiSplit: true,//not available in multitablecompo yet
          })
          return
        }

        // Show Only ToPay Amount(Detailed)
        if (detailedFilter?.Name === 'Show Only ToPay Amount') {
          const mainHeader = buildShowOnlyToPayMainHeader(loginCountryId, allownFormatLR, UseToPayAsCOD,intCompanyID)
          const summaryHeader = buildShowOnlyToPaySummaryHeader(UseToPayAsCOD)
          const tableData = transformShowOnlyToPay(table, mainHeader)
          const summaryData = groupDataByVehicleAndPayment(table)
          const subHeaderRow = buildSubHeaderRow(mainHeader)
          openReportInNewTab({
            reportName: 'Dispatch Report - Show Only ToPay Amount (Detailed)',
            isMultiTable: true,
            tables: [
              { criteriaHeaders, criteriaData, mainHeader, tableData: [subHeaderRow, ...tableData], totalSubKey: 3, colSpanMarker: 'ReceiverGSTN' },
              { mainHeader: summaryHeader, tableData: summaryData },
            ],
            isShowManageColumn: true,
            showColumnBorders: true,
            manageColumnID: 'KeyOnlyToPayColWithFormat_07081',
            isClampHeaderToTwoLines: true,
            isWrapEntryText: true,
          })
          return
        }
      }

    } catch (err) {
      updateAlertError({ show: true, msg: 'Something went wrong', nextId: '' })
    } finally {
      dispatch(updateLoader(false))
    }
  }

  const handleClick2 = () => {
    let url = ''
    if (showSummaryReport?.id === 1 && detailedFilter?.id === 3) {
      updateAlert({ show: true, msg: 'This Report in Not Available in Old Format' })
    } else if (showSummaryReport?.id === 0 && detailedFilter?.id === 7) {
      updateAlert({ show: true, msg: 'This Report in Not Available in Old Format' })
    } else if (showSummaryReport?.id === 0 && detailedFilter?.id === 8) {
      updateAlert({ show: true, msg: 'This Report in Not Available in Old Format' })
    } else if (showSummaryReport?.id === 0 && detailedFilter?.id === 9) {
      updateAlert({ show: true, msg: 'This Report in Not Available in Old Format' })
    } else if (showSummaryReport?.id === 0 && detailedFilter?.id === 6) {
      updateAlert({ show: true, msg: 'This Report in Not Available in Old Format' })
    } else if (showSummaryReport?.id === 0 && detailedFilter?.id === 5) {
      url = urls.challanWiseDispatch
      const urlData = urls.challanWiseDispatchParams
      urlData.chk = loginData?.BusCrsCheckSum
      urlData.dispatchdate = fromDate?.format('YYYY-MM-DD')
      urlData.dispatchTodate = toDate?.format('YYYY-MM-DD')
      urlData.intBranchId = loginData?.intBranchID
      urlData.VehicleNo = selVehicle?.name === 'All' ? `--All--` : selVehicle?.name
      urlData.intConsignmentType = 0
      urlData.AllowViewAllReport = 1
      urlData.intAllowExportToExcel = 1
      url = appendToUrl(url, urlData)
      window.open(url, '_blank')
    } else if ((showSummaryReport?.id === 1 && detailedFilter?.id === 1) || (showSummaryReport?.id === 0 && detailedFilter?.id === 0)) {
      url = urls.withVehicleAndCharteDate
      const urlData = urls.dispatchReportParams
      urlData.chk = loginData?.BusCrsCheckSum
      urlData.intCompanyId = loginData?.intCompanyID
      urlData.FromDate = fromDate?.format('YYYY-MM-DD')
      urlData.ToDate = toDate?.format('YYYY-MM-DD')
      urlData.BranchId = loginData?.intBranchID
      urlData.BranchName = selFromBranch?.name
      urlData.CommonCompanyId = intCompanyID
      urlData.CommonUserId = intUserID
      urlData.ToCityId = selDestCity?.id
      urlData.VehicleNo = selVehicle?.name === 'All' ? `--All--` : selVehicle?.name
      urlData.CompanyName = loginData?.strCompanyName
      urlData.CityName = `--All Cities--`
      urlData.WithoutVehicleGroup = showSummaryReport?.id === 1 && detailedFilter?.id === 2 ? `True` : `False`
      urlData.DBranchName = selBranch?.name === 'All' ? `--All--` : selBranch?.name
      urlData.BranchName = loginData?.strBranchName
      urlData.ToBranchID = selBranch?.id
      urlData.FromBranchID = selFromBranch?.id
      urlData.UserID = intUserID
      urlData.IsSummaryHamaliReport = showSummaryReport?.id === 0 && detailedFilter?.id == 1 ? 1 : 0 //with hamali and cartage
      urlData.IsSummaryOtherReport = showSummaryReport?.id === 0 && detailedFilter?.id == 2 ? 1 : 0 //with other charge
      urlData.IsBranchSummaryReport = showSummaryReport?.id === 0 && detailedFilter?.id == 3 ? 1 : 0 //branch summary
      urlData.IsVehicleDateSummaryReport =
        (showSummaryReport?.id === 1 && detailedFilter?.id == 1) || (showSummaryReport?.id === 0 && detailedFilter?.id == 0) ? 1 : 0 //with vehicle and charte date for dispatch
      urlData.IsVehicleDateSummaryOnlyReport = showSummaryReport?.id === 0 && detailedFilter?.id == 0 ? 1 : 0 //with vehicle and charte date for Summary
      urlData.VehicleID = selVehicle.id || 0
      urlData.CancelledDispatchOnly = reportType?.id === 1 ? 1 : 0
      urlData.PaymentType = selPaymentTpe.typeId
      urlData.mode = reportType?.id === 1 ? `CancelDispatch` : `Dispatch`
      url = appendToUrl(url, urlData)
      window.open(url, '_blank')
    } else {
      url = urls.dispatchReport
      const urlData = urls.dispatchReportParams
      urlData.chk = loginData?.BusCrsCheckSum
      urlData.intCompanyId = loginData?.intCompanyID
      urlData.FromDate = fromDate?.format('YYYY-MM-DD')
      urlData.ToDate = toDate?.format('YYYY-MM-DD')
      urlData.BranchId = loginData?.intBranchID
      urlData.BranchName = selFromBranch?.name
      urlData.CommonCompanyId = intCompanyID
      urlData.CommonUserId = intUserID
      urlData.ToCityId = selDestCity?.id
      urlData.VehicleNo = selVehicle?.name === 'All' ? `--All--` : selVehicle?.name
      urlData.CompanyName = loginData?.strCompanyName
      urlData.CityName = `--All Cities--`
      urlData.WithoutVehicleGroup = showSummaryReport?.id === 1 && detailedFilter?.id === 2 ? `True` : `False`
      urlData.DBranchName = selBranch?.name === 'All' ? `--All--` : selBranch?.name
      urlData.BranchName = loginData?.strBranchName
      urlData.ToBranchID = selBranch?.id
      urlData.FromBranchID = selFromBranch?.id
      urlData.UserID = intUserID
      urlData.IsSummaryHamaliReport = showSummaryReport?.id === 0 && detailedFilter?.id == 1 ? 1 : 0 //with hamali and cartage
      urlData.IsSummaryOtherReport = showSummaryReport?.id === 0 && detailedFilter?.id == 2 ? 1 : 0 //with other charge
      urlData.IsBranchSummaryReport = showSummaryReport?.id === 0 && detailedFilter?.id == 3 ? 1 : 0 //branch summary
      urlData.IsVehicleDateSummaryReport =
        (showSummaryReport?.id === 1 && detailedFilter?.id == 1) || (showSummaryReport?.id === 0 && detailedFilter?.id == 0) ? 1 : 0 //with vehicle and charte date for dispatch
      urlData.IsVehicleDateSummaryOnlyReport = showSummaryReport?.id === 0 && detailedFilter?.id == 0 ? 1 : 0 //with vehicle and charte date for Summary
      urlData.VehicleID = selVehicle.id || 0
      urlData.CancelledDispatchOnly = reportType?.id === 1 ? 1 : 0
      urlData.PaymentType = selPaymentTpe.typeId
      urlData.mode = reportType?.id === 1 ? `CancelDispatch` : `Dispatch`
      url = appendToUrl(url, urlData)
      window.open(url, '_blank')
    }
  }
  const callFilterAPi = () => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      const data = {
        intFromCityID: 0,
        intFromBranchID: 0,
        intToCityID: 0,
        intToBranchID: 0,
        intCompanyID: selCompany?.CompanyID,
        dtFrom: fromDate.format('YYYY-MM-DD'),
        dtTo: toDate.format('YYYY-MM-DD'),
        strVehicleNo: '--All--',
        intPaymentType: 0,
        LoginUserID: intUserID,
        IsOnlyCancelledDispatch: -1,
      }
      getDispatchReportDetailsFilter(data)
    }
  }
  const handlekeyDown = (e, prevId, nextId, currentId, currentButton) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      document.getElementById(nextId).focus()
    } else if (e.key === 'Escape') {
      document.getElementById(prevId).focus()
    } else if (e.key === ' ') {
      if (currentButton === 'go') {
        callFilterAPi()
      } else {
        document.getElementById(currentId).click()
      }
    }
  }

  const reportName = 'Dispatch'
  const headerData = {
    fromDate: moment(fromDate).format('MM/DD/YYYY'),
    toDate: moment(toDate).format('MM/DD/YYYY'),
    dispatchByBranch: selFromBranch?.dispatchByBranch || loginData?.strBranchName,
    destinationCity: selDestCity?.name,
    destinationBranch: selBranch?.name,
    vehicleNumber: selVehicle?.name,
    paymentType: selPaymentTpe?.name || 'All',
    reportType: reportType?.Name,
    reportView: showSummaryReport?.Name,
    reportOption: detailedFilter?.Name,
  }
  const selectedSourceCity = (obj) => {
    setShowReport(false)
    setSelDestCity(obj)
    setSelBranch(
      extractAndFilter(dispatchDetailsData, 'DispatchedToBranchFilter', 'DispatchedToBranchIDFilter', true).filter(
        (val) => val.id === obj.cityId || val.id == 0
      )?.[0]
    )
    if (obj.id === 0 && obj.name === 'All') {
      setVehicleData(
        removeDuplicatesFromArray1(
          extractAndFilter(dispatchDetailsData, 'VehicleNoForFilter', 'VehicleIDForFilter', true, 'DispatchedToCityIDFilter'),
          'id',
          'name'
        )
      )
    } else {
      let filterData = extractAndFilter(
        dispatchDetailsData,
        'VehicleNoForFilter',
        'VehicleIDForFilter',
        true,
        'DispatchedToCityIDFilter'
      ).filter((val) => val.cityId === obj.cityId)
      setVehicleData(filterData)
    }
  }

  const selectedDispatchByBranch = (obj) => {
    setShowReport(false)
    setSelFromBranch(obj)
    setSelDestCity(
      removeDuplicatesFromArray(
        extractAndFilter(
          dispatchDetailsData,
          'DispatchedToCityFilter',
          'DispatchedToCityIDFilter',
          true,
          'DispatchedToBranchIDFilter'
        ).filter((val) => val.id !== obj.cityId),
        'id'
      )?.[0]
    )
  }
  let BranchOption = [...([JAIN_COMPANY_ID, JAIN_NEW].includes(intCompanyID) ? [] : [{ name: 'All', id: 0, FromCityID: 0 }]),
  ...extractAndFilter(dispatchDetailsData, 'DispatchFromBranchFilter', 'DispatchFromBranchIDFilter', false, 'FromCityID'),
  ];
  let DestCityOption = [
    { name: 'All', id: 0, FromCityID: 0 },
    ...extractAndFilter(dispatchDetailsData, 'DispatchedToCityFilter', 'DispatchedToCityIDFilter', false, 'FromCityID'),
  ]
  let DestBranchOption = [
    { name: 'All', id: 0, FromCityID: 0 },
    ...extractAndFilter(dispatchDetailsData, 'DispatchedToBranchFilter', 'DispatchedToBranchIDFilter', false, 'FromCityID'),
  ]
  const destinationCityListTemp = dispatchDetailsData.reduce((acc, item) => {
    if (!acc.set.has(item.DispatchedToCityIDFilter)) {
      acc.set.add(item.DispatchedToCityIDFilter)
      acc.list.push({ name: item.DispatchedToCityFilter, id: item.DispatchedToCityIDFilter, cityId: item.DispatchedToCityIDFilter })
    }
    return acc
  }, { set: new Set(), list: [] }).list
  const destinationCityList = [
    { name: 'All', id: 0, cityId: 0 },
    ...destinationCityListTemp
      .filter((val) => val.id !== selFromBranch?.cityId)
      .sort((a, b) => a.name.localeCompare(b.name)),
  ]
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <ReportHeading reportName={reportName} />
        <Box sx={sx.reportFlex} style={{ background: '#fff', borderBottom: '1px solid #ccc', paddingBottom: '10px' }}>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id="selectCompnay"
              prevId={'generateDiv'}
              nextId={'ArrowForwardIosIcon1'}
              label="Selected Company"
              data={ChildCompanyList}
              defaultvalue={selCompany?.CompanyName}
              disabled={AllowGroupofCompanies === 1 ? false : true}
              onSelect={(val) => setSelCompany(val)}
              dataKey={`CompanyName`}
              idKey={`CompanyID`}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
            <Datepicker
              name={'from_collection_date'}
              label={`From Dispatch Date`}
              id="fromDate"
              nextId={'toDate'}
              dateChange={(date) => {
                setFromDate(date)
                focusElemnt('toDate')
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
            <Datepicker
              name={'to_dispatch_date'}
              label={'To Dispatch Date'}
              id="toDate"
              nextId={'ArrowForwardIosIcon2'}
              prevId={'fromDate'}
              dateChange={(date) => {
                setToDate(date)
                focusElemnt('ArrowForwardIosIcon2')
              }}
              width="100%"
            />
          </Item>
          <Item
            tabIndex={0}
            id="ArrowForwardIosIcon2"
            sx={sx.itemsx}
            className="enable-wrapper"
            variant="contained"
            onClick={callFilterAPi}
            onKeyDown={(e) => handlekeyDown(e, 'fromDate', 'dispatchByBranch', 'ArrowForwardIosIconBtn', 'go')}
            style={{
              display: 'flex',
              justifyContent: 'center',
              width: '4%',
              color: 'white',
              backgroundColor: '#fe5200',
              borderRadius: '4px',
              fontSize: 'large'
            }}
          >
            GO
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              label={lb.dispatchByBranch}
              id="dispatchByBranch"
              nextId={'destination'}
              prevId={'ArrowForwardIosIcon2'}
              data={
                roleRights?.Table1?.[0]?.AllowViewAllBranchReport == 0 && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 1
                  ? [
                    ...([JAIN_COMPANY_ID, JAIN_NEW].includes(intCompanyID) ? [] : [{ name: 'All', id: 0, FromCityID: 0 }]),
                    ...BranchOption?.filter((val) => val.cityId == loginData?.intBranchCityID),
                  ]
                  : BranchOption
              }
              dataKey={`name`}
              idKey={`id`}
              disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
              defaultvalue={BranchOption.length ? selFromBranch?.name : ''}
              value={selFromBranch?.name || ''}
              isObjArr={true}
              onSelect={(val) => selectedDispatchByBranch(val)}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              label={lb.destination}
              id="destination"
              nextId={'destinationBranch'}
              prevId={'dispatchByBranch'}
              data={destinationCityList}
              dataKey={`name`}
              idKey={`id`}
              defaultvalue={DestCityOption.length ? selDestCity?.name : ''}
              value={selDestCity?.name || ''}
              onSelect={(val) => {
                selectedSourceCity(val)
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              label={lb.destinationBranch}
              id="destinationBranch"
              nextId={'vehicleList'}
              prevId={'destination'}
              data={
                extractAndFilter(
                  dispatchDetailsData,
                  'DispatchedToBranchFilter',
                  'DispatchedToBranchIDFilter',
                  true,
                  'DispatchedToCityIDFilter'
                ).filter(
                  (val) =>
                    val.id === 0 ||
                    (val.cityId === selDestCity.cityId &&
                      !(val.cityId === selFromBranch?.cityId && val.id === selFromBranch?.id))
                )
              }
              dataKey={`name`}
              idKey={`id`}
              onSelect={(val) => {
                setShowReport(false)
                setSelBranch(val)
              }}
              defaultvalue={DestBranchOption.length ? selBranch?.name : ''}
              value={selBranch?.name || ''}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              label={lb.vehicle}
              id="vehicleList"
              defaultvalue={'All'}
              value={selVehicle?.name || ''}
              data={vehicleData || []}
              dataKey={`name`}
              idKey={`id`}
              onSelect={(val) => {
                setShowReport(false)
                setSelVehicle(val)
              }}
              nextId={'paymentBookingType'}
              prevId={'destinationBranch'}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id="paymentBookingType"
              label={lb.paymentType}
              isObjArr={true}
              onSelect={(val) => {
                setShowReport(false)
                setSelPaymentType(val)
              }}
              // data={paymentModesWithAll || []}
              data={(paymentModesWithAll || []).map((item) => { if (UseToPayAsCOD === 1) { if (item.typeId === 2) { return { ...item, name: 'COD' }; } if (item.typeId === 7) { return { ...item, name: 'COD Manual' }; } if (item.typeId === 9) { return { ...item, name: 'COD DDDV' }; } if (item.typeId === 4) { return null; } } return item; }).filter(Boolean)}
              dataKey={`name`}
              idKey={`typeId`}
              defaultvalue={modeAllPayments.name}
              nextId={'ReportType'}
              prevId={'vehicleList'}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id="ReportType"
              label={'Report Type'}
              data={reportTypeDispatchFilter}
              defaultvalue={reportTypeDispatchFilter[0].Name}
              idKey={`id`}
              dataKey={`Name`}
              onSelect={(val) => {
                setShowReport(false)
                setReportType(val)
              }}
              nextId={'reportView'}
              prevId={'paymentBookingType'}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id="reportView"
              label={'Report View'}
              data={reportViewDispatchFilter}
              defaultvalue={reportViewDispatchFilter[1].Name}
              idKey={`id`}
              dataKey={`Name`}
              onSelect={(val) => {
                setShowReport(false)
                setShowSummaryReport(val)
              }}
              nextId={'reportOption'}
              prevId={'ReportType'}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id="reportOption"
              label={'Report Option'}
              defaultvalue={detailedFilter?.Name || ''}
              value={detailedFilter?.Name || ''}
              data={reportOptionsData}
              idKey={`id`}
              dataKey={`Name`}
              onSelect={(val) => {
                setShowReport(false)
                setDetailedFilter(val)
              }}
              nextId={'generateDiv'}
              prevId={'reportView'}
              width="230px"
            />
          </Item>
          <Item
            id="generateDiv"
            tabIndex={0}
            sx={sx.itemsx}
            onKeyDown={(e) => navigation3(e, showReport ? 'DispatchPrintBtn' : 'fromDate', 'reportOption', () => handleClick1())}
          >
            <SplitButton
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
              // hideToggle={true}
              prevId={'reportOption'}
              id1={'generateBtn'}
              // id="generateBtn"
              nextId={'fromDate'}
              onClick1={handleClick1}
              onClick2={handleClick2}
              disabled={false}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, display: 'none' }}>
            <RefreshSvg />
          </Item>
        </Box>
      </Item>
    </>
  )
}

const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  getDispatchReportInputFilters,
  getDispatchReportDetailsFilter,
  getBranchList,
  getOwnParentCompany,
  updateAlertError,
  updateModal,
  getCargoSettingFilterData,
  updateAlert,
}
export default connect(mapStateToProps, mapDispatchToProps)(DispatchReportNew)
